<template>
  <div class="container">
    <h1>ガイドライン</h1>
    <h3>本サイトとは</h3>
    <p>
    本サイトは
    <a href="http://www.irasutoya.com/">かわいいフリー素材集 いらすとや</a>
    (以後「いらすとや本家」と表記)のファンサイトです。<br/>
    いらすとや本家を運用されるみふねたかし氏に許可を得て、いらすとや本家様のコンテンツの利便性とアクセスの向上を目的として検索機能を提供しています。<br/>
    </p>
    <h3>利用ガイド</h3>
    <p>
    いらすとを利用される際は本サイトから直接画像を取得するのではなく
    必ずいらすとや本家様サイトへ飛んでいただき、そこから取得されるようお願いします。<br/>
    また、<a href="http://www.irasutoya.com/p/terms.html">いらすとや本家様サイトの利用規約</a>も必ずご確認ください。
    </p>
    <h3>注意</h3>
    <p>
    本サイトはあくまでいらすとや本家様のコンテンツの利便性とアクセスの向上を目的としたサイトです。<br/>
    そのため本サイトがいらすとや本家様の不都合・不利益になっているとわかった時点で速やかにサイトの修正もしくは閉鎖を行います。<br/>
    前触れなくサイトの機能が変更されたりサイトが閉鎖される可能性がありますのでご留意ください。
    </p>
    <h3>連絡方法</h3>
    <p>
    本サイトに関するお問い合わせは
    <router-link :to="{ name: 'Contact' }">コンタクトページに記載された連絡先</router-link>へお願いします。<br/>
    <span class="text-danger">
      本サイトに関していらすとや本家様およびみふねたかし氏へ問い合わせることは
      迷惑になりますので絶対におやめください。
    </span>
    </p>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'ガイドライン'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guide.vue